import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8',    
        'Authorization': ConstantsService.AUTH_TOKEN,         
    })    
};

@Injectable()
export class ExamService {

    constructor(private http: HttpClient) { }

    getFirstQuestion(rootUrl: string, usercode: string, student_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/exams', {usercode:usercode, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }


    getQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, deficulty_lebel: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/questionByNo', {usercode:usercode, student_id:student_id, exam_id:exam_id, index:index, deficulty_lebel:deficulty_lebel}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    setQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, answer_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/questionByNo', {usercode:usercode, exam_id:exam_id, student_id:student_id,  index:index, answer_id:answer_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    setQuestionAnswer(rootUrl: string, usercode: string, exam_id: number, students:any):Observable<any> {
        return this.http.post<any>(rootUrl+'question/answer/submited', {usercode:usercode, exam_id:exam_id, students:students}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    setExamPauseResume(rootUrl: string, usercode: string, student_id:number, exam_id: number, status: string):Observable<any> {
        return this.http.post<any>(rootUrl+'student/log', {usercode:usercode, exam_id:exam_id, student_id:student_id, status:status}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    getVivaFirstQuestion(rootUrl: string, usercode: string, student_id:number, exam_id: number, assessor_id:number, viva_by:string):Observable<any> {
        return this.http.post<any>(rootUrl+'question/viva', {usercode:usercode, student_id:student_id, exam_id:exam_id, assessor_id:assessor_id, viva_by:viva_by}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    getVivaQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, answer_id: number, assessor_id:number, viva_by:string):Observable<any> {
        return this.http.post<any>(rootUrl+'question/vivaquestionByNo', {usercode:usercode, student_id:student_id, exam_id:exam_id, index:index, assessor_id:assessor_id, viva_by:viva_by}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    
    setVivaQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, question_id:number, req_by: string, answer_type:string, file:any, marks:number, assessor_id:number, viva_by:string):Observable<any> {
        return this.http.post<any>(rootUrl+'question/viva/saveweb', {usercode:usercode, exam_id:exam_id, student_id:student_id,  index:index, question_id:question_id, req_by:req_by, answer_type:answer_type, file:file, marks:marks, assessor_id:assessor_id, viva_by:viva_by}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    saveExamPic(rootUrl: string, usercode: string, student_id:number, exam_id: number, req_by:string, file:any):Observable<any> {
        return this.http.post<any>(rootUrl+'exam/student/image', {usercode:usercode, exam_id:exam_id, student_id:student_id, req_by:req_by, file:file}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    setVivaSubmit(rootUrl: string, usercode: string, student_id:number, exam_id: number, type:number, assessor_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/viva/submit', {usercode:usercode, exam_id:exam_id, student_id:student_id, type:type, assessor_id:assessor_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    getVCFirstQuestion(rootUrl: string, usercode: string, student_id:number, exam_id: number, index:number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/practical', {usercode:usercode, student_id:student_id, exam_id:exam_id, index:index}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    setVCQuestionByIndex(rootUrl: string, usercode: string, assessor_id:number, student_id:number, practical_id: number, index: number, question_id: number, marks:number, maxmarks:number, exam_id:number, chapter_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/setVCMarks', {usercode:usercode, practical_id:practical_id, student_id:student_id,  index:index, question_id:question_id, marks:marks, maxmarks:maxmarks, assessor_id:assessor_id, exam_id:exam_id, chapter_id:chapter_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    getVCQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/vcquestionByNo', {usercode:usercode, exam_id:exam_id, student_id:student_id, index:index}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    getVivaPCFirstQuestion(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/vivapc', {usercode:usercode, exam_id:exam_id, student_id:student_id, index:index}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    setVivaPCQuestionByIndex(rootUrl: string, usercode: string, exam_id:number, student_id:number, index: number, answers:any, checked: number, question_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/vivapcsubmitByIndex', {usercode:usercode, exam_id:exam_id, student_id:student_id, index:index, answers:answers, checked:checked, question_id:question_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    getVivaPCFByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/vivapcquestionByNo', {usercode:usercode, exam_id:exam_id, student_id:student_id, index:index}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getV2FirstQuestion(rootUrl: string, usercode: string, student_id:number, exam_id: number, assessor_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/practicalviva/exam', {usercode:usercode, student_id:student_id, exam_id:exam_id, assessor_id:assessor_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    getV2QuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, assessor_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'question/practicalviva/questionByIndex', {usercode:usercode, exam_id:exam_id, student_id:student_id,  index:index, assessor_id:assessor_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }    
    setPracticalQuestionByIndex(rootUrl: string, usercode: string, student_id:number, exam_id: number, index: number, question_id:number, answer_type:string, file:any, marks:number, assessor_id:number, remark:string, viva_by:string):Observable<any> {
        return this.http.post<any>(rootUrl+'question/practicalviva/saveAnswer', {usercode:usercode, exam_id:exam_id, student_id:student_id,  index:index, question_id:question_id, answer_type:answer_type, file:file, marks:marks, assessor_id:assessor_id, remark:remark, viva_by:viva_by}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    setPracticalSubmit(rootUrl: string, usercode: string, student_id:number, exam_id: number, assessor_id:number):Observable<any> {
    return this.http.post<any>(rootUrl+'question/practicalviva/submitExam', {usercode:usercode, exam_id:exam_id, student_id:student_id, assessor_id:assessor_id}, httpOptions)
        .pipe(map(user => {
            return user;
        }));
    }    
    setVivaPCSubmit(rootUrl: string, usercode: string, student_id:number, exam_id: number, assessor_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/k/matrixSubmit', {usercode:usercode, exam_id:exam_id, student_id:student_id, assessor_id:assessor_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }     
}